var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLangchain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C15.84 0 31.68 0 48 0 C48 15.84 48 31.68 48 48 C32.16 48 16.32 48 0 48 C0 32.16 0 16.32 0 0 Z ",
    fill: "#E8E6FC",
    transform: "translate(0,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.12792969 -0.01933594 2.25585938 -0.03867188 3.41796875 -0.05859375 C11.61256369 -0.01010502 11.61256369 -0.01010502 15.7421875 2.9453125 C18.08200145 6.51222888 18.24768961 8.43793819 17.5 12.625 C15.3272578 15.25516161 13.55326212 17.09836894 10.5 18.625 C6.90235402 18.91882599 3.29574606 18.90296031 -0.3125 18.9375 C-1.31087891 18.96650391 -2.30925781 18.99550781 -3.33789062 19.02539062 C-10.73107012 19.08942216 -10.73107012 19.08942216 -14.63671875 16.73046875 C-17.05194078 14.00131849 -17.45834134 12.99298482 -17.875 9.3125 C-17.5 5.625 -17.5 5.625 -15.7578125 2.93359375 C-10.75047367 -0.61477226 -5.9865094 -0.10262588 0 0 Z ",
    fill: "#345053",
    transform: "translate(24.5,15.375)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.67456717 0.37792797 3.80611814 0.79766916 5.703125 2.77734375 C6.21359375 3.49019531 6.7240625 4.20304687 7.25 4.9375 C7.77078125 5.64777344 8.2915625 6.35804687 8.828125 7.08984375 C10 9 10 9 10 11 C7.1875 10.875 7.1875 10.875 4 10 C2.25 7 2.25 7 1 4 C0.34 3.67 -0.32 3.34 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#DBDBEF",
    transform: "translate(14,19)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.54226981 3.79588866 -2.20127563 5.47211993 -5 8 C-5.99 7.67 -6.98 7.34 -8 7 C-7.1875 4.0625 -7.1875 4.0625 -6 1 C-3 0 -3 0 0 0 Z ",
    fill: "#5C7178",
    transform: "translate(35,21)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangchain);
export default __webpack_public_path__ + "static/media/langchain.361db07cb5daf16f3f94818157ae429e.svg";
export { ForwardRef as ReactComponent };